import { Modal } from 'bootstrap';
class DocumentForm {
    constructor() {
        this.uncompletedDocumentSelector = '#uncompletedDocument';
        this.modalOpen = false;
        // Inicializace při vytvoření instance
        this.initDocumentItem();
        this.initDocumentAutocomplete();
        this.initOnchangeLink();
        this.tryOpenInlineAdd();
        // this.protectNavigation();

        this.lastQuery = '';
        this.activeRequest = null;
        this.isLoading = false;
        this.debounceTimer = null;
    }

    initDocumentItem() {
        // Načtení inputů pro položky faktury
        const documentItemCount = document.getElementById('document-item-count');
        const documentItemPrice = document.getElementById('document-item-price');
        const documentItemPriceBase = document.getElementById('document-item-price-base');

        if (documentItemCount && documentItemPrice && documentItemPriceBase) {
            documentItemPrice.addEventListener('input', () => {
                this.updateDocumentItemPrice(documentItemCount, documentItemPrice, documentItemPriceBase);
            });
        }
    }

    updateDocumentItemPrice(documentItemCount, documentItemPrice, documentItemPriceBase) {
        const itemCount = parseInt(documentItemCount.value, 10);
        const price = parseFloat(documentItemPrice.value);

        if (!isNaN(itemCount) && !isNaN(price)) {
            const priceBase = itemCount * price;

            documentItemPriceBase.value = priceBase.toFixed(2);
        }
    }

    initOnchangeLink() {
        document.querySelectorAll('[data-onchange-link]').forEach((element) => {
            const provide = element.getAttribute('data-onchange-link');
            if (!provide) return;

            let previousValue = element.value;

            const triggerRequest = (value) => {
                if (!value) return;

                naja.makeRequest('POST', provide, { value: value }, { history: false })
                    .then(response => console.log('Response:', response))
                    .catch(error => console.error('Error:', error));
            };

            // Detekce klasické změny (uživatelské)
            element.addEventListener('change', (event) => {
                const newValue = event.target.value;
                if (newValue !== previousValue) {
                    previousValue = newValue;
                    triggerRequest(newValue);
                }
            });

            // Sledování programových změn
            const observer = new MutationObserver(() => {
                const currentValue = element.value;
                if (currentValue !== previousValue) {
                    previousValue = currentValue;
                    triggerRequest(currentValue);
                }
            });

            observer.observe(element, { attributes: true, childList: false, subtree: false });

            // Pro jistotu fallback i přes polling (v případě že se hodnota změní bez DOM změny)
            setInterval(() => {
                const currentValue = element.value;
                if (currentValue !== previousValue) {
                    previousValue = currentValue;
                    triggerRequest(currentValue);
                }
            }, 10);
        });
    }

    tryOpenInlineAdd() {
        const gridWrapper = document.querySelector('.datagrid-wrapper');
        const completeBtn = document.querySelector(this.uncompletedDocumentSelector);

        if (!gridWrapper || !completeBtn) return;

        if (gridWrapper.querySelector('.datagrid-row-inline-add')){
            const newInput = document.getElementById('invoice-item-name');
            if (newInput) {
                const active = document.activeElement;
                const isInputFocused = active && (
                    active.tagName === 'INPUT' ||
                    active.tagName === 'TEXTAREA' ||
                    active.isContentEditable
                );

                if (!isInputFocused) {
                    newInput.focus();
                }
                // obs.disconnect();
            }
            return;
        }

        const showInlineAddLink = gridWrapper.querySelector('a[href*="showInlineAdd"]');
        if (showInlineAddLink) {
            naja.uiHandler.clickElement(showInlineAddLink);
        }
    }

    protectNavigation() {
        const completeBtn = document.querySelector(this.uncompletedDocumentSelector);
        const wrapper = completeBtn?.closest('form');

        const isInsideSafeZone = (el) => {
            return el.closest('.datagrid-wrapper') ||
                el.closest('.datagrid-row-inline-add') ||
                el.closest('.modal') ||
                (wrapper && wrapper.contains(el));
        };

        document.addEventListener('click', (event) => {
            if (event.__navigationChecked) return;
            event.__navigationChecked = true;

            const target = event.target.closest('a, button, input[type="submit"]');
            if (!target || this.modalOpen) return;

            if (completeBtn && !isInsideSafeZone(target)) {
                const href = target.getAttribute('href');
                if (href || target.hasAttribute('data-href') || target.type === 'submit') {
                    event.preventDefault();
                    this.modalOpen = true;
                    this.showWarningDialog();
                }
            }
        });

        naja.uiHandler.addEventListener('interaction', (event) => {
            if (event.__navigationChecked) return;
            event.__navigationChecked = true;

            const element = event.detail.element;
            if (!element || this.modalOpen) return;

            if (completeBtn && !isInsideSafeZone(element)) {
                event.preventDefault();
                this.modalOpen = true;
                this.showWarningDialog();
            }
        });
    }

    showWarningDialog() {
        //if (this.modalOpen) return; // Zabrání znovuotevření modalu
        const modal = document.createElement('div');
        modal.classList.add('modal', 'fade');
        modal.tabIndex = -1;
        modal.role = 'dialog';
        modal.innerHTML = `
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Máte rozpracovaný doklad. Nejprve jej musíte stornovat pomocí tlačítka "Zrušit"</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn btn-secondary">Zpět</button>
                </div>
            </div>
        </div>
        `;

        document.body.appendChild(modal);

        const bootstrapModal = new Modal(modal);

        modal.querySelector('.btn-secondary').addEventListener(
            'click', () => {
                bootstrapModal.hide();
                this.modalOpen = false;
            }
        );
        modal.addEventListener('hidden.bs.modal', () => {
            this.modalOpen = false;
            modal.remove();
        });

        this.modalOpen = true;
        bootstrapModal.show();
    }

    initDocumentAutocomplete() {
        this.documentContactInput = document.getElementById('document-contact');
        if (!this.documentContactInput || this.documentContactInput.classList.contains('autocomplete-attached')) return;

        this.documentContactInput.classList.add('autocomplete-attached');
        this.suggestionsContainer = document.getElementById('suggestions-container') || this.createSuggestionsContainer();

        this.documentContactInput.addEventListener('keyup', () => this.loadSuggestions());

        this.documentContactInput.addEventListener('blur', () => {
            setTimeout(() => {
                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
            }, 200);
        });
    }

    createSuggestionsContainer() {
        const container = document.createElement('div');
        container.id = 'suggestions-container';
        container.classList.add('list-group');
        container.style.position = 'absolute';
        container.style.zIndex = '9999';
        container.style.height = '35vh';
        document.body.appendChild(container);
        return container;
    }

    loadSuggestions() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            const query = this.documentContactInput.value;
            const provide = this.documentContactInput.getAttribute('data-provide');

            if (query.length <= 2 || query === this.lastQuery || this.isLoading) return;

            this.lastQuery = query;
            this.isLoading = true;
            if (this.activeRequest) this.activeRequest.abort();

            this.documentContactInput.classList.add('loading');

            const inputRect = this.documentContactInput.getBoundingClientRect();
            this.suggestionsContainer.style.top = `${inputRect.bottom + window.scrollY}px`;
            this.suggestionsContainer.style.left = `${inputRect.left + window.scrollX}px`;
            this.suggestionsContainer.style.width = `${inputRect.width * 4}px`;

            this.activeRequest = naja.makeRequest('POST', provide, { query }, { history: false })
                .then(response => {
                    this.displaySuggestions(response, query);
                })
                .finally(() => {
                    this.documentContactInput.classList.remove('loading');
                    this.isLoading = false;
                    this.activeRequest = null;
                });
        }, 300);
    }

    displaySuggestions(suggestions, query) {
        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.style.display = 'flex';

        Object.entries(suggestions).forEach(([id, product]) => {
            const item = document.createElement('a');
            item.classList.add('list-group-item', 'list-group-item-action');
            item.style.backgroundColor = 'rgb(232, 245, 252)';
            item.innerHTML = this.highlightMatch(product.name, query);

            item.addEventListener('click', () => {
                this.documentContactInput.value = product.name;
                var documentName = document.getElementById('document-name');
                if (documentName) {
                    documentName.value = product.name;
                }
                var documentStreet = document.getElementById('document-street');
                if (documentStreet) {
                    documentStreet.value = product.street;
                }
                var documentLocality = document.getElementById('document-locality');
                if (documentLocality) {
                    documentLocality.value = product.locality;
                }
                var documentPostal = document.getElementById('document-postal');
                if (documentPostal) {
                    documentPostal.value = product.postal;
                }
                var documentIco = document.getElementById('document-ico');
                if (documentIco) {
                    documentIco.value = product.ico;
                }
                var documentDic = document.getElementById('document-dic');
                if (documentDic) {
                    documentDic.value = product.dic;
                }

                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
            });

            this.suggestionsContainer.appendChild(item);
        });
    }

    highlightMatch(text, query) {
        return text.replace(new RegExp(`(${query})`, 'gi'), '<strong>$1</strong>');
    }

    static initialize() {
        // Vytvoření instance třídy pouze pokud jsou v DOM potřebné elementy
        new DocumentForm();
    }
}

// Inicializace při načtení DOM
document.addEventListener('DOMContentLoaded', () => {
    DocumentForm.initialize();
});

// Připojení na události Naja pro AJAXové operace
naja.addEventListener('complete', () => {
    DocumentForm.initialize();
});

export default DocumentForm;
